import { createSlice } from "@reduxjs/toolkit";
import { InvoiceListApi, InvoiceByIdApi,insertInvoice, getMemberInvoice, deleteMemberInvoice, updateMemberInvoice } from "../api/InvoiceApi"

const initState = {
    loading: false,
    resData: [],
    invoice: {},
    invoices: [],
}

export const InvoiceSlice = createSlice({
    name: "InvoiceSlice",
    initialState: initState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(InvoiceListApi.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(InvoiceListApi.fulfilled, (state, action) => {
            state.loading = false;
            state.resData = action?.payload;
        })
        builder.addCase(InvoiceListApi.rejected, (state) => {
            state.loading = false;
        })

        builder.addCase(InvoiceByIdApi.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(InvoiceByIdApi.fulfilled, (state, action) => {
            state.loading = false;
            state.invoice = action?.payload;
        })
        
        builder.addCase(InvoiceByIdApi.rejected, (state) => {
            state.loading = false;
        })


        builder.addCase(insertInvoice.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(insertInvoice.fulfilled, (state, action) => {
            state.loading = false;
           
        })
        
        builder.addCase(insertInvoice.rejected, (state) => {
            state.loading = false;
        })

        builder.addCase(getMemberInvoice.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(getMemberInvoice.fulfilled, (state, action) => {
            state.invoices = action?.payload?.data;
            state.loading = false;
           
        })
        
        builder.addCase(getMemberInvoice.rejected, (state) => {
            state.loading = false;
        })


        builder.addCase(deleteMemberInvoice.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(deleteMemberInvoice.fulfilled, (state, action) => {
            state.loading = false;
           
        })
        
        builder.addCase(deleteMemberInvoice.rejected, (state) => {
            state.loading = false;
        })


        builder.addCase(updateMemberInvoice.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(updateMemberInvoice.fulfilled, (state, action) => {
            state.loading = false;
           
        })
        
        builder.addCase(updateMemberInvoice.rejected, (state) => {
            state.loading = false;
        })
    }
})

export default InvoiceSlice.reducer
